export default "__VITE_ASSET__f7a7590b__"